<template>
  <section class="w-full py-10">
    <div class="mx-auto flex flex-col md:flex-row">
      <!-- Left Section -->
      <div class="flex flex-col justify-center items-center md:items-start md:text-left md:w-[30%]">
        <h2 class="text-[26px] md:text-[40px] font-semibold text-[#2e2e2e] leading-snug mt-12">
          {{ $t("mobileApp.title") }}
        </h2>
        <p class="text-[16px] md:text-[20px] text-[#2e2e2e] font-semibold mt-3">
          {{ $t("mobileApp.subtitle") }}
        </p>

        <!-- QR Code -->
        <div class="mt-6 flex text-center items-center lg:justify-start">
          <img
            :src="`${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_LANDING_PATH}AppQRCode.png`"
            alt="QR Code"
            class="w-48 max-w-full"
          />
        </div>

        <!-- Store Badges -->
        <div class="flex flex-col sm:flex-row text-center md:justify-start gap-4 mt-6">
          <a
            :href="`https://play.google.com/store/apps/details?id=roofhub.pro&hl=${locale}`"
            target="_blank"
            rel="noopener noreferrer">
            <img
              :src="googlePlayImg"
              alt="Google Play"
              class="drop-shadow transition-transform hover:scale-105 store-badge"/>
          </a>
          <a
            href="https://apps.apple.com/us/app/roof-hub/id1434560046"
            target="_blank"
            rel="noopener noreferrer">
            <img
              :src="appleStoreImg"
              alt="Apple Store"
              class="drop-shadow transition-transform hover:scale-105 object-contain store-badge"
            />
          </a>
        </div>
      </div>

      <!-- Right Section -->
      <div class="md:w-[70%] flex justify-end -mr-8 mt-28 md:m-0">
        <img
          :src="appMockupImg"
          alt="App Mockup"
          class="h-auto object-contain max-w-7xl drop-shadow"
          width="100%"/>
      </div>
    </div>
  </section>
</template>

<script setup>
    import { MEDIA_ASSET_BASE_URL, MEDIA_ASSET_LANDING_PATH } from "./../../../config/constants.js";
    import { computed } from "vue";
import { useI18n } from "vue-i18n";

    const { t, locale } = useI18n();

    function getStoreImage(name) {
        return computed(() =>
            `${MEDIA_ASSET_BASE_URL}${MEDIA_ASSET_LANDING_PATH}${name}${locale.value === "es" ? "ES" : ""}.png`
        );
    }

    const appleStoreImg = getStoreImage("AppleStore");
    const googlePlayImg = getStoreImage("GooglePlay");
    const appMockupImg = getStoreImage("AppMockup");
    
</script>

<style scoped>
.store-badge {
  transition: all 0.2s ease-in-out;
}

@media (max-width: 576px) {
  .store-badge {
    max-height: 300px;
    flex-grow: 0;
  }
}
</style>
